import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  permission?: string;
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  permission,
  children,
}) => {
  const { isAuthenticated, hasPermission } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/perfil" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/perfil" replace />;
  }

  return children;
};

export default ProtectedRoute;
